<template>

    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

            <ButtonsIcon 
                icon="mdi-delete-outline"
                color="red"
                small
                @clicked="emit('clicked', $event)"
                v-bind="attrs"
                v-on="on"
            />

        </template>

        <span>Excluir</span>

    </v-tooltip>
</template>

<script setup>

import { defineEmits } from 'vue';

const emit = defineEmits(['clicked'])

</script>